export default "__VITE_ASSET__B6Mf0Qfp__"